import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface PopupPayload {
	// horaEmbarque?: string;
	// origenFormateado?: string;

	data?: {
		horaEmbarque?: any;
		origenFormateado?: any;
		direccionEmbarque?: any;
		fechaFormateadaIda?: any;
		horaDesembarque?: any;
		destinoFormateado?: any;
		direccionDesembarque?: any;
		fechaFormateadaVuelta?: any;
		escalas?: any;
		localstorage?: any;
	};
	// agrega campos según necesites
}

@Injectable({ providedIn: 'root' })
export class PopupService {
	private _openSubject = new BehaviorSubject<PopupPayload | null>(null);
	readonly open$ = this._openSubject.asObservable();

	open(payload: PopupPayload) {
		this._openSubject.next(payload);
	}

	close() {
		this._openSubject.next(null);
	}
}
